const ones = [
    '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
    'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen',
    'seventeen', 'eighteen', 'nineteen'
];

const tens = [
    '', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
];

const scales = [
    '', 'thousand', 'million', 'billion', 'trillion'
];

function convertHundreds(num: number): string {
    let result = '';

    if (num > 99) {
        result += ones[Math.floor(num / 100)] + ' hundred';
        num %= 100;
        if (num > 0) result += ' ';
    }

    if (num > 19) {
        result += tens[Math.floor(num / 10)];
        num %= 10;
        if (num > 0) result += '-';
    }

    if (num > 0 && num < 20) {
        result += ones[num];
    }

    return result;
}

export default function numberToWord(num: number | string): string {
    const numValue = typeof num === 'string' ? parseInt(num, 10) : num;

    if (isNaN(numValue)) return '';
    if (numValue === 0) return 'zero';
    if (numValue < 0) return 'negative ' + numberToWord(-numValue);

    let result = '';
    let scaleIndex = 0;
    let workingNumber = numValue;

    while (workingNumber > 0) {
        const chunk = workingNumber % 1000;
        if (chunk !== 0) {
            const chunkText = convertHundreds(chunk);
            if (scaleIndex > 0) {
                result = chunkText + ' ' + scales[scaleIndex] + ' ' + result;
            } else {
                result = chunkText;
            }
        }
        workingNumber = Math.floor(workingNumber / 1000);
        scaleIndex++;
    }

    return result.trim();
}

// Alternative export for default import compatibility
export { numberToWord };